module.exports = __webpack_public_path__ + "img/ssyx_21.51cb22f4.jpg";